@use "sass:meta";
@use "sass:math";

@use "./variables"; // Bia sass variables - Re-usable rule values such as colours, spacing, and breakpoints

@use "./root"; // Carme CSS variables

// /* vendor-overrides/mq-settings START */
@use "./vendor-overrides/mq-settings";
// /* vendor-overrides/mq-settings END */

// START: GLOBALLY SHARED
// /* stylelint-disable */
// Third party code
@use "./vendor/responsive-bp/responsive";

@use "./vendor/reset"; // Remove browser defaults to ensure a common baseline to build styles upon

@use "./vendor/mq"; // Provides helpers for creating sensible breakpoints - see variables file

@use "./vendor-overrides/__all" as vendor-override;

// END: GLOBALLY SHARED

@use "./cta/__all" as cta;

// Tools: Reusable mixins and placeholders. If used in a component, should be imported for clarity.
@use "./tools/__all" as tool;

// Helpers: Reusable CSS classes you can drop into places to activate certain features or behaviours. Should not be imported, but used in markup
@use "./helpers/__all" as helper;

@use "./containers/__all" as container;

// Base: Tag-based default styles
@use "./base/__all" as base;

// Utils
@use "./utils/__all" as utils;

// Components: Each file is a BEM block, a component used throughout the site
@use "./components/__all" as component;
// /* stylelint-enable */

@use "./print";
